/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { NumberFigure } from './numberFigure';
import type { PointsFigure } from './pointsFigure';
import type { ListFigure } from './listFigure';

export type MetricsResponseFiguresItem = NumberFigure | PointsFigure | ListFigure;
